import { useInstance, onBeforeMount, onBeforeUpdate } from 'intact-vue-next';
export function useStyles(showValue) {
  var instance = useInstance();
  var barStyle;
  var thumbFirstStyle;
  var thumbSecondStyle;
  function updateStyle() {
    var _instance$get = instance.get(),
      max = _instance$get.max,
      min = _instance$get.min,
      range = _instance$get.range;
    var total = max - min;
    if (total > 0) {
      if (range) {
        var _showValue$value = showValue.value,
          first = _showValue$value[0],
          second = _showValue$value[1];
        barStyle = {
          width: toPercent(Math.abs(second - first), total),
          left: toPercent(Math.min(first, second) - min, total)
        };
        thumbFirstStyle = {
          left: toPercent(first - min, total)
        };
        thumbSecondStyle = {
          left: toPercent(second - min, total)
        };
      } else {
        var percent = toPercent(showValue.value - min, total);
        barStyle = {
          width: percent
        };
        thumbFirstStyle = {
          left: percent
        };
      }
    } else {
      barStyle = {
        width: '100%',
        left: '0'
      };
      thumbFirstStyle = {
        left: '100%'
      };
      thumbSecondStyle = {
        left: '0'
      };
    }
  }
  onBeforeUpdate(updateStyle);
  onBeforeMount(updateStyle);
  return function () {
    return {
      barStyle: barStyle,
      thumbFirstStyle: thumbFirstStyle,
      thumbSecondStyle: thumbSecondStyle
    };
  };
}
function toPercent(value, total) {
  return value / total * 100 + '%';
}